/** Směry kotev pro resizování (např. SE = Southeast) */
export const enum AnchorPoint {
    N = "N",
    NE = "NE",
    E = "E",
    SE = "SE",
    S = "S",
    SW = "SW",
    W = "W",
    NW = "NW",
}

/** Určuje, jakými směry lze měnit velikost picasso komponenty. */
export enum ResizeOptions {
    none = 0b00,
    horizontal = 0b01,
    vertical = 0b10,
    both = 0b11,
}

/** Popisuje, jakého typu je entity (Je to tu v podstatě jen proto, že Typescript neumí instanceof pro interfacy... jakmile to bude umět, tak klidně smazat!) */
export const enum EntityType {
    component = "component",
    link = "link",
}

/** Popisuje zakotvení komponenty vůči své rodičovské komponentě. */
export const enum AlignType {
    top = "top",
    bottom = "bottom",
    left = "left",
    right = "right",
    none = "none",
    client = "client",
}
